import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { BindingCreator, Validate } from '@dreryk/react-common';
import { CheckboxGroup } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';
import { MedicalConsentAndAuthorizationPrintBean } from '../../MedicalConsentAndAuthorizationsPrintModal';

import { useCreateCheckboxGroupAvailableValues } from './AuthorizationsToPrintCheckboxGroup.hooks';

type AuthorizationsToPrintCheckboxGroupProps = {
   readonly register: BindingCreator<MedicalConsentAndAuthorizationPrintBean>;
   readonly medicalDataAccessAuthorization?: MedicalDataAccessAuthorization[] | null;
};

const validate: Validate<MedicalConsentAndAuthorizationPrintBean> = (data, getValue) => {
   if (
      !(data as MedicalConsentAndAuthorizationPrintBean['confirmedAuthorizationsToPrint']).length &&
      !getValue('patientConsentToPrint')
   ) {
      return patientConsentsAndAuthorizationsTranslationKeys.printModal.chooseAtLeastOneToPrint;
   }

   return undefined;
};

const AuthorizationsToPrintCheckboxGroup = (props: AuthorizationsToPrintCheckboxGroupProps): JSX.Element => {
   const availableValues = useCreateCheckboxGroupAvailableValues(props.medicalDataAccessAuthorization ?? []);
   return (
      <CheckboxGroup
         availableValues={availableValues}
         controller={props.register('confirmedAuthorizationsToPrint', { validate: validate })}
         testId={'confirmedAuthorizationsToPrint'}
      />
   );
};

export { AuthorizationsToPrintCheckboxGroup };
